

export default {
    // apiHost: "http://localhost:8000"
    apiHost: process.env.REACT_APP_BACKEND_API_HOST,
    s3Host: process.env.REACT_APP_BACKEND_S3_HOST,
}

// const baseURL = 'http://localhost:8000'